import { ScreenSizes } from '@/css-helpers/media-query'

// eslint:disable:only-arrow-functions
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const w = window as any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const d = document as any

// Internet Explorer 6-11
export const isIE = /*@cc_on!@*/ false || !!d.documentMode

// Edge 20+
export const isEdge = !isIE && !!w.StyleMedia

export const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !w.MSStream

/** @deprecated Use useIsMobile() hook */
export const isMobile = () => window.innerWidth <= ScreenSizes.Mobile
/** @deprecated Use useIsMobile() hook */
export const isTablet = () => window.innerWidth < ScreenSizes.Desktop
/** @deprecated Use useIsDesktop() hook */
export const isDesktop = () => window.innerWidth >= ScreenSizes.Desktop
